import axios from 'axios';
import {
  COMMON_LOAD_PROJECT_VERSION_BEGIN,
  COMMON_LOAD_PROJECT_VERSION_SUCCESS,
  COMMON_LOAD_PROJECT_VERSION_FAILURE,
  COMMON_LOAD_PROJECT_VERSION_DISMISS_ERROR,
} from './constants';

export function loadProjectVersion(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COMMON_LOAD_PROJECT_VERSION_BEGIN,
    });
    const { projectId } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}versions/project/${projectId}/`,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COMMON_LOAD_PROJECT_VERSION_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COMMON_LOAD_PROJECT_VERSION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectVersionError() {
  return {
    type: COMMON_LOAD_PROJECT_VERSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_LOAD_PROJECT_VERSION_BEGIN:
      return {
        ...state,
        loadProjectVersionPending: true,
        loadProjectVersionError: null,
      };

    case COMMON_LOAD_PROJECT_VERSION_SUCCESS:
      return {
        ...state,
        loadProjectVersionPending: false,
        loadProjectVersionError: null,
        versions: action.data,
      };

    case COMMON_LOAD_PROJECT_VERSION_FAILURE:
      return {
        ...state,
        loadProjectVersionPending: false,
        loadProjectVersionError: action.data.error,
      };

    case COMMON_LOAD_PROJECT_VERSION_DISMISS_ERROR:
      return {
        ...state,
        loadProjectVersionError: null,
      };

    default:
      return state;
  }
}
